var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTreasureLogoGreen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logos / treasure-financial / logo-icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "logos / treasure-financial / logo-icon_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26 0L13.0045 7.5019L0 0V1.2248L19.3537 12.4011L26 8.5646V7.3398L19.3537 11.1763L18.3 10.5639L26 6.115V4.8902L17.2373 9.9515L16.1836 9.3391L26 3.6744V2.4496L15.1209 8.7267L14.0672 8.12331L26 1.2248V0ZM14.5895 14.5442L0 6.1147V4.8899L15.6522 13.9228V24.4687L14.5895 25.0811V14.5442ZM8.23138 13.32L0 8.5649V7.3401L13.5359 15.1482V15.4544V25.6941L13.0045 26.0003L12.4732 25.6941V15.7606L11.4105 15.1572V25.0817L10.3478 24.4693V14.5448L9.29408 13.9324V23.8659L8.23138 23.2445V13.32ZM16.7059 13.3197L0 3.67444V2.44964L17.7686 12.7073V23.2442L16.7059 23.8656V13.3197Z",
    fill: "#2F6B60"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTreasureLogoGreen);
export default __webpack_public_path__ + "static/media/treasure_logo_green.c2de61e9a52f79bdc0610bc51af8ddd7.svg";
export { ForwardRef as ReactComponent };